export default __webpack_public_path__ + "static/media/downArrow.6460b8d9.svg";